/**
 * Métricas do PRÓPRIO sistema (Painel do Portal de Gestão, 08/10/2026).
 *
 * Grava visita, produto aberto e carrinho em /api/painel/evento. Diferente do
 * GA4, vale no site e no app Android e não é barrado por bloqueador de
 * anúncio (é o nosso domínio). Sem dado pessoal: o "visitante" é um código
 * aleatório gerado no aparelho; quem está logado vai com o token, e o
 * servidor associa à conta.
 *
 * Nunca atrapalha o app: fire-and-forget, todo erro é engolido.
 */
import { API_URL } from '../api/client';

const CHAVE_VISITANTE = 'toa_visitante';
const CHAVE_VISITA = 'toa_visita_sessao';

const aleatorio = () => {
  try {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID().replace(/-/g, '');
  } catch { /* segue */ }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
};

let visitanteMemoria = null;
export function visitanteId() {
  try {
    let v = localStorage.getItem(CHAVE_VISITANTE);
    if (!v || !/^[A-Za-z0-9_-]{8,64}$/.test(v)) {
      v = aleatorio();
      localStorage.setItem(CHAVE_VISITANTE, v);
    }
    return v;
  } catch {
    // Navegação privada sem storage: um código por carregamento de página
    visitanteMemoria = visitanteMemoria || aleatorio();
    return visitanteMemoria;
  }
}

// Só conta onde há cliente de verdade: o domínio oficial, o app e o ambiente
// local (para validar). Prévia da Vercel e navegador automatizado (robô,
// teste) ficam de fora — o servidor ainda barra robô pelo User-Agent.
const deveContar = () => {
  try {
    if (navigator.webdriver === true) return false;
    if (window.Capacitor?.isNativePlatform?.() === true) return true;
    const h = window.location.hostname || '';
    return h.endsWith('toalugando.com.br') || h === 'localhost' || h === '127.0.0.1';
  } catch { return false; }
};

const origem = () => {
  try { return window.Capacitor?.isNativePlatform?.() === true ? 'app' : 'site'; } catch { return 'site'; }
};

/**
 * @param evento  'visita' | 'produto_visto' | 'carrinho_adicionado' | 'carrinho_visto'
 * @param extra   { equipamento_id?, valor? }
 */
export function registrarEvento(evento, extra = {}) {
  try {
    if (typeof fetch !== 'function' || !deveContar()) return;
    const corpo = { evento, visitante: visitanteId(), origem: origem() };
    if (extra.equipamento_id) corpo.equipamento_id = String(extra.equipamento_id);
    const valor = Number(extra.valor);
    if (Number.isFinite(valor) && valor > 0) corpo.valor = Number(valor.toFixed(2));
    const headers = { 'Content-Type': 'application/json' };
    try {
      const token = localStorage.getItem('toalugando_token');
      if (token) headers.Authorization = `Bearer ${token}`;
    } catch { /* sem storage */ }
    fetch(`${API_URL}/api/painel/evento`, {
      method: 'POST', headers, body: JSON.stringify(corpo), keepalive: true,
    }).catch(() => {});
  } catch { /* métrica nunca derruba o app */ }
}

/** Uma 'visita' por sessão do navegador/app (abrir o app de novo conta outra). */
export function registrarVisita() {
  try {
    if (sessionStorage.getItem(CHAVE_VISITA)) return;
    sessionStorage.setItem(CHAVE_VISITA, '1');
  } catch { /* sem storage: conta a cada carregamento */ }
  registrarEvento('visita');
}
